import Actions from "./actions";

export function updateLogin(data) {
  return { type: Actions.UPDATE_LOGIN_FETCH, data };
}

export function loginDataGet(data) {
  return { type: Actions.GET_LOGIN_FETCH, data };
}
